import { render, staticRenderFns } from "./newResourceList.vue?vue&type=template&id=c3011368&scoped=true"
import script from "./newResourceList.vue?vue&type=script&lang=js"
export * from "./newResourceList.vue?vue&type=script&lang=js"
import style0 from "./newResourceList.vue?vue&type=style&index=0&id=c3011368&prod&scoped=true&lang=css"
import style1 from "./newResourceList.vue?vue&type=style&index=1&id=c3011368&prod&lang=css"
import style2 from "./newResourceList.vue?vue&type=style&index=2&id=c3011368&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3011368",
  null
  
)

export default component.exports